/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyPharmacyGroupRegistrableTypename = "PharmacyPharmacyGroupRegistrable" as const;

/**
 *
 * @export
 * @interface PharmacyPharmacyGroupRegistrable
 */
export interface PharmacyPharmacyGroupRegistrable {
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyGroupRegistrable
   */
  chainId?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyGroupRegistrable
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyGroupRegistrable
   */
  name?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPharmacyGroupRegistrable
   */
  readonly __typename?: string;
}

export function PharmacyPharmacyGroupRegistrableFromJSON(json: any): PharmacyPharmacyGroupRegistrable {
  return PharmacyPharmacyGroupRegistrableFromJSONTyped(json, false);
}

export function PharmacyPharmacyGroupRegistrableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyPharmacyGroupRegistrable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPharmacyGroupRegistrableTypename,

    chainId: !exists(json, "chain_id") ? undefined : json["chain_id"],
    description: !exists(json, "description") ? undefined : json["description"],
    name: !exists(json, "name") ? undefined : json["name"],
  };
}

export function PharmacyPharmacyGroupRegistrableToJSON(object?: PharmacyPharmacyGroupRegistrable | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    chain_id: value.chainId,
    description: value.description,
    name: value.name,
  };
}
